import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../css/normalize.css";
import "../css/global.css";
import signinImage from "../assets/img/1.jpg";

function Cancelled() {
  const navigate = useNavigate();

  useEffect(() => {
    // Push a new state to the history stack
    window.history.pushState(null, null, window.location.href);
    document.body.style.backgroundImage = `url(${signinImage})`;
    document.body.style.backgroundSize = "cover";

    const handlePopState = () => {
      // Redirect to home when back button is clicked
      navigate("/subscription");
    };

    // Add event listener for popstate
    window.addEventListener("popstate", handlePopState);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("popstate", handlePopState);
      document.body.style.backgroundImage = "";
      document.body.style.backgroundSize = "";
    };
  }, [navigate]);

  return (
    <div
      className="togethere-background"
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        textAlign: "center",
        border: "1px solid #ccc",
        borderRadius: "4px",
      }}
    >
      <div className="sr-root">
        <div
          className="sr-main"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
            height: "50vh",
            width: "50vw",
            border: "1px solid #ccc",
            borderRadius: "4px",
            boxShadow:
              "0px 3px 3px -2px rgba(0,0,0,0.2), 0px 3px 4px 0px rgba(0,0,0,0.14), 0px 1px 8px 0px rgba(0,0,0,0.12)",
            background: "transparent",
            backdropFilter: "blur(10px)",
          }}
        >
          <header className="sr-header">
            <div className="sr-header__logo"></div>
          </header>
          <div className="sr-payment-summary completed-view">
            <h1>Your payment was canceled</h1>
            <button
              onClick={() => navigate("/subscription")}
              style={{
                backgroundColor: "#e9a132", // Mustard yellow color
                color: "white", // Assuming white text color
                padding: "10px 20px",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
                "&:hover": {
                  backgroundColor: "#ffdb58d1", // Slightly darker on hover
                },
              }}
            >
              Retry Again
            </button>
          </div>
        </div>
        <div className="sr-content"></div>
      </div>
    </div>
  );
}

export default Cancelled;
